import * as React from "react";
import TreeViewItem from "./TreeViewItem/TreeViewItem";

import styles from "./TreeView.scss";

interface IProps {
    data?: object[];
    titleField: string;
    childrenField: string;
    onResize?: () => void;
    depth?: number;
    updatePath: (path: object[]) => void;
    selectedPath?: object[];
    equalityComparer?: (object1: object, object2: object) => boolean;
}

interface IState {
    data?: object[];
    selectedPath: object[];
}

export class TreeView extends React.Component<IProps, IState> {
    public ref: React.RefObject<HTMLDivElement>;
    public itemHeight: number;

    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedPath: props.selectedPath || []
        };

        this.ref = React.createRef();

        this.selectItem = this.selectItem.bind(this);
        this.isActive = this.isActive.bind(this);
        this.updatePath = this.updatePath.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const state: Partial<IState> = {};

        if (nextProps.data !== prevState.data) {
            state.data = nextProps.data;
        }

        if (nextProps.selectedPath !== undefined 
            && nextProps.selectedPath !== prevState.selectedPath) {
            state.selectedPath = nextProps.selectedPath;
        }
        
        return state;
    }

    public selectItem(item: object) { 
        const depth = this.props.depth || 0;
        let newPath = this.state.selectedPath ? [...this.state.selectedPath] : [];
        newPath = newPath.slice(0, this.props.depth || 0);

        if (!this.state.selectedPath || this.state.selectedPath.length - 1 > depth || (this.props.equalityComparer && !this.props.equalityComparer(this.state.selectedPath[depth], item))) {
            newPath = [...newPath, item];
            this.updatePath(newPath);
        }
        else {
            this.updatePath(newPath);
        }
    }

    public isActive(item: object): boolean { 
        const selectedItem = this.state.selectedPath[this.props.depth || 0];
        if(this.props.equalityComparer) {
            return this.props.equalityComparer(item, selectedItem);
        }
        
        return item === selectedItem;
    }

    public updatePath(path: object[]): void {
        if (this.props.selectedPath === undefined) {
            this.setState({
                selectedPath: path
            });
        }
        this.props.updatePath(path);
    }

    public render() {
        return (
            <div className={styles.treeView}>
                <ul>
                    {this.state.data && this.state.data.map((item, i) =>
                        <TreeViewItem 
                            key={i}
                            item={item} 
                            isActive={this.isActive(item)} 
                            selectItem={this.selectItem} 
                            childrenField={this.props.childrenField} 
                            titleField={this.props.titleField}
                            onResize={this.props.onResize} 
                            depth={this.props.depth || 0}
                            selectedPath={this.state.selectedPath}
                            updatePath={this.updatePath}
                            equalityComparer={this.props.equalityComparer}
                            />
                    )}
                </ul>
            </div>
        );
    }
}

export default TreeView;


// WEBPACK FOOTER //
// ./src/Components/TreeView/TreeView.tsx